import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { RoleStateService } from '../services/role-state.service';

export const isEvaluatorGuard: CanActivateFn = () => {
  const roleStateService: RoleStateService = inject(RoleStateService);
  const router: Router = inject(Router);
  const forbiddenUrlTree: UrlTree = router.createUrlTree(['/forbidden']);

  return roleStateService.ensureRolesLoaded().pipe(
    map((roles): boolean | UrlTree => {
      if (roles.isEvaluator) {
        return true;
      }

      return forbiddenUrlTree;
    }),
    catchError(() => of(forbiddenUrlTree))
  );
};
